module.exports = {
	"name": "websocket",
	"description": "Websocket Client & Server Library implementing the WebSocket protocol as specified in RFC 6455.",
	"keywords": [
		"websocket",
		"websockets",
		"socket",
		"networking",
		"comet",
		"push",
		"RFC-6455",
		"realtime",
		"server",
		"client"
	],
	"author": "Brian McKelvey <brian@worlize.com> (https://www.worlize.com/)",
	"contributors": [
		"Iñaki Baz Castillo <ibc@aliax.net> (http://dev.sipdoc.net)"
	],
	"version": "1.0.24",
	"repository": {
		"type": "git",
		"url": "https://github.com/theturtle32/WebSocket-Node.git"
	},
	"homepage": "https://github.com/theturtle32/WebSocket-Node",
	"engines": {
		"node": ">=0.8.0"
	},
	"dependencies": {
		"debug": "^2.2.0",
		"nan": "^2.3.3",
		"typedarray-to-buffer": "^3.1.2",
		"yaeti": "^0.0.6"
	},
	"devDependencies": {
		"buffer-equal": "^1.0.0",
		"faucet": "^0.0.1",
		"gulp": "git+https://github.com/gulpjs/gulp.git#4.0",
		"gulp-jshint": "^2.0.4",
		"jshint-stylish": "^2.2.1",
		"jshint": "^2.0.0",
		"tape": "^4.0.1"
	},
	"config": {
		"verbose": false
	},
	"scripts": {
		"install": "(node-gyp rebuild 2> builderror.log) || (exit 0)",
		"test": "faucet test/unit",
		"gulp": "gulp"
	},
	"main": "index",
	"directories": {
		"lib": "./lib"
	},
	"browser": "lib/browser.js",
	"license": "Apache-2.0"
};


//////////////////
// WEBPACK FOOTER
// ./~/websocket/package.json
// module id = 802
// module chunks = 0